(function () {
    'use strict';

    angular
        .module('sodCommon')
        .directive('sodSearchBarApply', sodSearchBarApply);

    function sodSearchBarApply() {
        return {
            restrict: 'E',
            scope: { config: '=' },
            transclude: true,
            templateUrl: 'common/components/sod-search-bar-apply',
            controller: sodSearchBarApplyCtrl,
            controllerAs: 'vm',
            bindToController: true,
            compile: sodSearchBarApplyCompile,
            link: sodSearchBarApplyLink,
        };

        function sodSearchBarApplyCompile(tElement, attrs, transclude) {
            return function ($scope) {
                transclude($scope, function (clone) {
                    tElement.append(clone);
                });
            };
        }

        function sodSearchBarApplyLink(scope, elem, attr) {
        }
    }

    function sodSearchBarApplyCtrl(lodash, $element, $scope, FilterFactory, $httpParamSerializer) {
        var vm = this;

        this.$onInit = function() {
            vm.filters = {};
            init();
        }

        function getSearchUrl() {
            vm.searchUrl = ['portal/jobs', '?', $httpParamSerializer({ filter: vm.filters })].join('');
        }

        function init() {
            getSearchUrl();
            var filtersChangeListener = $scope.$on(
                [FilterFactory.eventPrefix, lodash.get(vm, 'config.id', null)].join('.'),
                function (e, data) {
                    vm.filters = data;
                    getSearchUrl();
                }
            );

            $scope.$on('$destroy', function () {
                filtersChangeListener();
            });
        }
    }
})();